<div *ngIf="warrantyForm && warrantyType">
  <div class="row">
    <div class="col-12">
      <h3 translate>CLAIM_FORM</h3>
      <div translate>CLAIM_INFORMATION</div>
    </div>
  </div>
  <form [formGroup]="warrantyForm">
    <div class="row form-helo-claim">
      <div class="col-6" formGroupName="customer">
        <lib-gung-text-input
          gungTranslate="COMPANY"
          formControlName="company"
          placeholder="{{ 'COMPANY' | translate }}"
        ></lib-gung-text-input>
        <lib-gung-text-input
          gungTranslate="CUSTOMER_NUMBER"
          formControlName="customerNumber"
          placeholder="{{ 'CUSTOMER_NUMBER' | translate }}"
        ></lib-gung-text-input>
        <lib-gung-text-input
          gungTranslate="ORDER_NUMBER"
          formControlName="orderNumber"
          placeholder="{{ 'ORDER_NUMBER' | translate }}"
        ></lib-gung-text-input>
        <lib-forms-message-error
          [controller]="warrantyForm.get('customer').get('orderNumber')"
        ></lib-forms-message-error>
        <lib-gung-text-input
          gungTranslate="STREET_ADDRESS"
          formControlName="streetAddress"
          placeholder="{{ 'STREET_ADDRESS' | translate }}"
        ></lib-gung-text-input>
        <lib-gung-text-input
          gungTranslate="POSTAL_CODE_CITY"
          formControlName="postalCodeCity"
          placeholder="{{ 'POSTAL_CODE_CITY' | translate }}"
        ></lib-gung-text-input>
        <!-- <lib-gung-text-input gungTranslate="COUNTRY" formControlName="country" placeholder="{{'country' | translate}}"></lib-gung-text-input> -->
        <lib-meta-select-input
          formControlName="country"
          table="xr"
          metaId="landskod"
          metaDisplay="land"
        ></lib-meta-select-input>
        <lib-gung-text-input
          gungTranslate="PHONE_NUMBER"
          formControlName="phoneNumber"
          placeholder="{{ 'PHONE_NUMBER' | translate }}"
        ></lib-gung-text-input>
        <lib-forms-message-error
          [controller]="warrantyForm.get('customer').get('phoneNumber')"
        ></lib-forms-message-error>
        <lib-gung-text-input
          gungTranslate="EMAIL"
          formControlName="emailAddress"
          placeholder="{{ 'EMAIL' | translate }}"
        ></lib-gung-text-input>
        <lib-forms-message-error
          [controller]="warrantyForm.get('customer').get('emailAddress')"
        ></lib-forms-message-error>
      </div>
      <div class="col-6" formGroupName="claim">
        <lib-gung-select-option-input
          gungTranslate="TYPE"
          [optionsList]="warrantyType"
          formControlName="type"
        ></lib-gung-select-option-input>
        <lib-forms-message-error [controller]="warrantyForm.get('claim').get('type')"></lib-forms-message-error>
        <lib-gung-text-input
          *ngIf="!warrantyForm.get('claim').get('otherType').disabled"
          gungTranslate="OTHER"
          formControlName="otherType"
          placeholder="{{ 'OTHER' | translate }}"
        ></lib-gung-text-input>
        <lib-forms-message-error [controller]="warrantyForm.get('claim').get('otherType')"></lib-forms-message-error>
        <lib-gung-text-area-input
          gungTranslate="DESCRIBE_THE_ISSUE"
          rowsNumber="13"
          formControlName="description"
          blockResize="true"
        ></lib-gung-text-area-input>
        <lib-forms-message-error [controller]="warrantyForm.get('claim').get('description')"></lib-forms-message-error>
      </div>
    </div>
  </form>
  <div class="row">
    <div class="col-12">
      <button type="button" class="btn btn-primary float-right" (click)="sendWarranty($event)" translate>SEND</button>
    </div>
  </div>
</div>
